module.exports = __webpack_public_path__ + "media/images/map_icons/Dart-34651849bc45bd4f36a98b9d6730c5e4.svg";